import ProjectGroup from 'actions/project-group';

export default ProjectGroup.createReducer();